import React from 'react';
import {ScrollView} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {FlexView, Spacer, Spacing} from '/component/base/Storybook';

import DefaultStory from './Default';
import UserStory from './User';

storiesOf('base', module).add('Avatar', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <DefaultStory />
        <Spacer size={24} />
        <UserStory />
      </FlexView>
    </Spacing>
  </ScrollView>
));
